export const root = 'chain-item.get-started';
